"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.History = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var History = function History(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#History_svg__History_svg__clip0_17471_91701)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.016 8c0 3.314-2.665 6-5.953 6a5.921 5.921 0 01-4.55-2.132c-.307-.365-.798-.546-1.248-.39-.6.208-.87.91-.483 1.413A7.902 7.902 0 008.062 16C12.447 16 16 12.418 16 8s-3.554-8-7.937-8c-2.864 0-5.374 1.529-6.77 3.82l-.51-.334c-.43-.282-.8 0-.775.55l.119 2.748c.021.446.375.67.79.518l2.568-.977c.518-.2.64-.646.2-.935l-.728-.477A5.94 5.94 0 018.063 2c3.287 0 5.953 2.686 5.953 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5a1 1 0 10-2 0v3.582a1 1 0 00.422.816l2 1.418a1 1 0 001.156-1.632L9 8.065V5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "History_svg__History_svg__clip0_17471_91701"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

exports.History = History;
var _default = History;
exports.default = _default;